import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const NotificationPage = lazy(() => import('@/containers/Views/Notifications/NotificationPage'));

const NotificationsRouter = (
  <Route path="notifications">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Notifications} 
          permissions={EBasicActions.Find}
        >
          <NotificationPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default NotificationsRouter;
